<template>
  <b-form class="union-form">
    <b-form-group label="Название профсоюза">
      <b-input type="text" v-model="value.name" />
    </b-form-group>
  </b-form>
</template>

<script>
import UnionModel from "@/components/Forms/Union/models/unionModel";

export default {
  props: {
    value: {
      type: UnionModel,
      required: true
    }
  }
};
</script>
